import { IWebGetMapDataResponse } from '../../repositories/favorites/v1/web-get-map-data';
import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux';

export enum EMapActionTypes {
  SetMapData = 'MAP :: SET_MAP_DATA',
  SetMapDataFailed = 'MAP :: SET_MAP_DATA_FAILED',
  SetMapDataLoading = 'MAP :: SET_MAP_DATA_LOADING',
  OpenMap = 'MAP :: OPEN_MAP',
  CloseMap = 'MAP :: CLOSE_MAP',
  SetActivePin = 'MAP :: SET_ACTIVE_PIN',
  RemoveActivePin = 'MAP :: REMOVE_ACTIVE_PIN',
}

export type TMapActions =
  | ITypedReduxAction<EMapActionTypes.SetMapData, IWebGetMapDataResponse>
  | ITypedReduxAction<EMapActionTypes.SetMapDataLoading, void>
  | ITypedReduxAction<EMapActionTypes.SetMapDataFailed, void>
  | ITypedReduxAction<EMapActionTypes.OpenMap, void>
  | ITypedReduxAction<EMapActionTypes.CloseMap, void>
  | ITypedReduxAction<EMapActionTypes.SetActivePin, number>
  | ITypedReduxAction<EMapActionTypes.RemoveActivePin, void>;

export const setMapData: (payload: IWebGetMapDataResponse) => TMapActions = actionGenerator<
  EMapActionTypes.SetMapData,
  IWebGetMapDataResponse
>(EMapActionTypes.SetMapData);

export const setMapDataLoading: () => TMapActions = actionGenerator<EMapActionTypes.SetMapDataLoading>(
  EMapActionTypes.SetMapDataLoading,
);

export const setMapDataFailed: () => TMapActions = actionGenerator<EMapActionTypes.SetMapDataFailed>(
  EMapActionTypes.SetMapDataFailed,
);

export const openMap: () => TMapActions = actionGenerator<EMapActionTypes.OpenMap>(EMapActionTypes.OpenMap);

export const closeMap: () => TMapActions = actionGenerator<EMapActionTypes.CloseMap>(EMapActionTypes.CloseMap);

export const setActivePin: (payload: number) => TMapActions = actionGenerator<EMapActionTypes.SetActivePin, number>(
  EMapActionTypes.SetActivePin,
);

export const removeActivePin: () => TMapActions = actionGenerator<EMapActionTypes.RemoveActivePin>(
  EMapActionTypes.RemoveActivePin,
);
